module.exports = "https://trybtryb-legacy.web.app/img/blur-special-mobile.97c07762.svg";